import renderText from './renderText';
import renderDivider from './renderDivider';
import CirclePercentage from '../../CirclePercentage';

export default function ValuePercentage(params) {
    const value = params.value;
    const percentage = params.data[params.otherFields?.percentage];
    const valueString = params.data[params.otherFields?.valueString];

    if (isNaN(parseInt(value, 10)) || isNaN(parseInt(percentage, 10))) return null;

    const valuePercentageCell = document.createElement('div');
    valuePercentageCell.classList.add('w5-value-percentage-cell');
    const text = renderText(value, valueString);
    const divider = renderDivider();
    const circle = CirclePercentage(percentage, params);
    if (!text || !circle) return null;
    valuePercentageCell.appendChild(text);
    valuePercentageCell.appendChild(divider);
    valuePercentageCell.appendChild(circle);
    return valuePercentageCell;
}
